import { motion } from 'framer-motion';

export function Footer() {
  return (
    <nav className=" z-10 bg-white border-t border-[#ffece6] px-2">
      <div className="flex w-full items-center justify-between p-2">
        <img
          alt="Logo"
          src="https://coach.hupo.co/logos/icon/orange/icon.svg"
          className="h-6 w-auto"
        />
        <a
          target="_blank"
          className="text-sm text-gray-500 underline hover:text-gray-600 cursor-pointer"
        >
          Terms and conditions
        </a>
      </div>
    </nav>
  );
}

export function AIAvatar({ isAISpeaking }: { isAISpeaking: boolean }) {
  return (
    <div className="relative">
      <img
        alt="AI Avatar"
        src="https://dopmo1eihgbgm.cloudfront.net/67135d6f890cc59eb99e65f9/ai-headshot.webp"
        className="h-48 w-48 rounded-full"
      />
      {isAISpeaking && <SpeakingAnimation />}
    </div>
  );
}

export function SpeakingAnimation() {
  return (
    <div className="absolute inset-0">
      <motion.div
        className="absolute inset-0 border-4 border-primary rounded-full"
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.7, 0.3, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="absolute inset-0 border-4 border-primary rounded-full"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.7, 0.3, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.5,
        }}
      />
    </div>
  );
}
